/* unplugin-vue-components disabled */import { render } from "./TransferRadioBtn.vue?vue&type=template&id=74c79f9c&scoped=true"
import script from "./TransferRadioBtn.vue?vue&type=script&lang=js"
export * from "./TransferRadioBtn.vue?vue&type=script&lang=js"

import "./TransferRadioBtn.vue?vue&type=style&index=0&id=74c79f9c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c79f9c"]])

export default __exports__